document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-stitch-add]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled) return;
  const label = button.innerHTML;
  button.disabled = true;
  button.textContent = 'ADDING…';
  try {
    const response = await fetch(form.action + '.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Could not add this item.');
    const cartResponse = await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart.js` : '/cart.js');
    if (cartResponse.ok) {
      const cart = await cartResponse.json();
      document.querySelectorAll('.cart-count-bubble span:first-child').forEach((node) => { node.textContent = cart.item_count; });
      document.querySelectorAll('.cart-count-bubble').forEach((node) => { node.hidden = cart.item_count === 0; });
      document.querySelectorAll('[data-stitch-cart-count]').forEach((node) => { node.textContent = cart.item_count ? String(cart.item_count) : ''; });
    }
    button.textContent = 'ADDED ✓';
    window.setTimeout(() => { button.innerHTML = label; button.disabled = false; }, 1700);
  } catch (error) {
    button.textContent = 'TRY AGAIN';
    button.disabled = false;
    window.setTimeout(() => { button.innerHTML = label; }, 2000);
  }
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-copy-code]');
  if (!button) return;
  try {
    await navigator.clipboard.writeText(button.dataset.copyCode);
    const previous = button.textContent;
    button.textContent = 'COPIED ✓';
    window.setTimeout(() => { button.textContent = previous; }, 1800);
  } catch (_) {
    button.textContent = button.dataset.copyCode;
  }
});
